import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../../hooks/hooks";

import { RootState } from "../store";
import { LoadingType } from "../../types";
import { doFetch } from "../../utils/doFetch";

interface DocumentViewerState {
  base64String: string;
  documentFetchStatus: LoadingType;
}
const initialState = {
  base64String: "",
  documentFetchStatus: "idle",
} as DocumentViewerState;

export const previewSearchWarrantDocument = createAsyncThunk<
  any,
  {
    formObject: any;
    formType: string;
    templateType: string;
    fieldName: string;
  },
  { state: RootState; rejectValue: string }
>(
  "commonForm/previewSearchWarrantDocument",
  async (data, { getState, rejectWithValue }) => {
    const { formObject, formType, templateType, fieldName } = data;
    let { token } = getState().login;

    try {
      const response: any = await doFetch({
        url:
          `searchwarrantservices/previewSearchWarrantDocument/${templateType}/${formType}/${fieldName}`,
        token,
        type: "POST",
        body: formObject,
      });
      if (response.ok) {
        return response.text();
      }
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Error while generating pdf. Try again later."
      );
    }
  }
);

const documentViewerSlice = createSlice({
  name: "documentViewer",
  initialState,
  reducers: {
        resetDocumentViewData: (state: DocumentViewerState) => {
          return {
            ...state,
            ...initialState,
          };
        },
  },
  extraReducers(builder) {
    builder
      .addCase(previewSearchWarrantDocument.pending, (state) => {
        state.documentFetchStatus = "loading";
      })
      .addCase(previewSearchWarrantDocument.fulfilled, (state, action) => {
        state.base64String = action.payload;
        state.documentFetchStatus = "success";
      })
      .addCase(previewSearchWarrantDocument.rejected, (state, action) => {
        state.documentFetchStatus = "error";
        state.base64String = '';
      }) 
  },
});

export const { resetDocumentViewData } =
  documentViewerSlice.actions;

export const useDocumentViewerReducer = () =>
  useAppSelector((state) => state.documentViewerReducer);
export default documentViewerSlice.reducer;
